'use strict';

var _require = require('./Component');

var CopyToClipboard = _require.CopyToClipboard;


module.exports = CopyToClipboard;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-copy-to-clipboard/lib/index.js
 ** module id = 2335
 ** module chunks = 0
 **/